import React, { useCallback, useEffect } from 'react'
import { Button, Modal } from 'semantic-ui-react'

interface Props {
  open: boolean
  setOpen: (status: boolean) => void
  onConfirm: () => void
}

export const ConfirmationModal = (props: React.PropsWithChildren<Props>) => {
  const { open, setOpen, onConfirm, children } = props

  const close = useCallback(() => setOpen(false), [setOpen])
  const confirm = useCallback(() => {
    onConfirm()
    close()
  }, [close, onConfirm])

  useEffect(() => {
    const onKeydown = (e: KeyboardEvent) => {
      // checking if open is true IS NECESSARY – otherwise you'll fire off a ton
      // of deletions
      if (e.key === 'Enter' && open) {
        confirm()
      }
    }

    window.addEventListener('keydown', onKeydown)

    // https://stackoverflow.com/questions/53464595/how-to-use-componentwillmount-in-react-hooks
    // returned function will be called on component unmount
    return () => {
      window.removeEventListener('keydown', onKeydown)
    }
  }, [confirm, open])

  return (
    <Modal size="mini" open={open} onClose={close}>
      {children}
      <Modal.Actions>
        <Button onClick={close}>No</Button>
        <Button primary onClick={confirm}>
          Yes
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
